import { useState } from 'react';
import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import { ReportAttachment } from '../api';

function isImage(contentType?: string): boolean {
  return !!contentType && contentType.toLowerCase().startsWith('image/');
}

export function AttachmentView({ attachment }: { attachment: ReportAttachment }) {
  const [imageFailed, setImageFailed] = useState(false);
  const { url, downloadUrl, contentType, filename, attachmentId } = attachment;
  const label = filename || attachmentId || 'attachment';
  const saveHref = downloadUrl || url || undefined;

  const nameLink = saveHref ? (
    <Link href={saveHref} external>
      {label}
    </Link>
  ) : (
    <span>{label}</span>
  );

  if (url && isImage(contentType) && !imageFailed) {
    return (
      <figure style={{ margin: 0 }}>
        <img
          src={url}
          alt={label}
          onError={() => setImageFailed(true)}
          style={{ maxWidth: '100%', height: 'auto', display: 'block', borderRadius: 4 }}
        />
        <Box variant="small">{nameLink}</Box>
      </figure>
    );
  }

  return nameLink;
}
